import { useCallback } from 'react';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { TextInput, PasswordInput, Button, Paper, Title, Text, Group, Stack, Center, Box, useMantineTheme } from '@mantine/core';
import logo from './../../assets/logo_lg.png';
import { useTranslation } from 'react-i18next';

export const Register = () => {

    const { t } = useTranslation();
    const theme = useMantineTheme();

    const handleSubmit = useCallback(async e => {
        e.preventDefault();
        const { email, password, repeatPassword } = e.target.elements;

        if (password.value !== repeatPassword.value) {
            alert("Passwords do not match");
            return;
        }

        const auth = getAuth();
        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email.value, password.value);
            const user = userCredential.user;
            console.log(user);
            // Further logic for saving username and activationId can be added here
        } catch (e) {
            alert(e.message);
        }
    }, []);

    return (
        <Center style={{ height: '100vh' }}>
            <Box style={{ width: 400 }}>
                <Paper radius="md" p="xl" withBorder shadow="md">
                    <Center>
                        <img src={logo} alt="Logo" width={200} />
                    </Center>
                    <Title order={2} align="center" mt="md" mb="lg">
                        {t('register.title')}
                    </Title>
                    <form onSubmit={handleSubmit}>
                        <Stack spacing="md">
                            <TextInput
                                name="email"
                                label={t('login.email')}
                                placeholder="your-email@example.com"
                                type="email"
                                required
                            />
                            <PasswordInput
                                name="password"
                                label={t('login.password')}
                                placeholder=""
                                required
                            />
                            <PasswordInput
                                name="repeatPassword"
                                label={t('register.repeat.password')}
                                placeholder=""
                                required
                            />
                 
                            <Group position="apart">
                                <Button type="submit" fullWidth style={{ backgroundColor: theme.colors.nga[1] }}>
                                    {t('register.button')}
                                </Button>
                            </Group>
                        </Stack>
                    </form>
                    <Text size="sm" align="center" mt="md">
                        {t('register.back.to.login')} <a href="/login">{t('login.button')}</a>
                    </Text>
                </Paper>
            </Box>
        </Center>
    );
};
